<template>
    <header class="top_bar">
        <div class="top_notice">体验天数剩余 <strong v-if="day >= 0">{{ day }}</strong> 天 · 商务咨询 136 3527 5043</div>
        <div class="profile" v-if="memberInfo">
            <img class="avatar" :src="(memberInfo.avatar || 'avatar/default.png') | imgFormat" />
            <div class="profile_copy"><strong>{{ memberInfo.nickName }}</strong><span>{{ memberInfo.organizationName || '创作与教学中心' }}</span></div>
            <el-dropdown @command="handleCommand">
                <i class="iconfont icon-zhankai profile_arrow"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">账号管理</el-dropdown-item>
                    <el-dropdown-item command="2">退出账号</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </header>
</template>

<script>
import dayjs from "dayjs";
import { delCookie } from "@/plugins/utils";
export default {
    data() {
        return {
            memberInfo: "",
            day: 0,
        };
    },
    created() {
        this.$ajax.post("/user/user/getInfo").then(res => {
            if (res.msg === "教师审核未通过，请联系管理员") {
                this.$router.replace({ path: "/err/examine" });
                return;
            }
            this.memberInfo = res.data;
            const newDate = new Date();
            this.day = dayjs(res.data.organizationExpireTime).diff(dayjs(newDate), "day");
            if (dayjs(res.data.organizationExpireTime).diff(dayjs(newDate), "second") < 0) {
                this.$router.replace({ path: "/err/expire" });
                return;
            }
            this.$store.dispatch("setMemberInfoAsync", res.data || {});
            this.$emit("load");
        });
    },
    methods: {
        clickItem(item) {
            console.log(item);
        },
        handleCommand(type) {
            if (type === "2") {
                this.outLogin();
            } else {
                this.$router.push({ path: "/account" });
            }
        },
        outLogin() {
            this.$ajax.delete("/login/logout").then(res => {
                localStorage.removeItem("access_token");
                localStorage.removeItem("authToken");
                delCookie("flower_info");
                this.$router.replace({
                    path: "/login",
                });
            });
        },
    },
};
</script>
<style lang="scss">
.expire_tip {
    text-align: center;
    > div {
        &:first-child {
            font-size: 18px;
            line-height: 1.3em;
        }
        &:last-child {
            font-size: 14px;
            line-height: 1.3em;
            margin-top: 15px;
        }
    }
}
</style>
<style lang="scss" scoped>
.top_bar {
    position: sticky;
    top: 0;
    z-index: 20;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
    padding: 0 32px;
    color: #6b766f;
    border-bottom: 1px solid #e8eee9;
    background: rgba(255,255,255,.94);
    backdrop-filter: blur(18px);
    .top_notice { flex: 1; text-align: center; font-size: 13px; }
    .top_notice strong { color: #21965b; font-size: 15px; }
    .profile { display: flex; align-items: center; gap: 10px; min-width: 145px; }
    .avatar { width: 38px; height: 38px; object-fit: cover; border: 3px solid #edf8f1; border-radius: 50%; }
    .profile_copy { min-width: 0; }
    .profile_copy strong, .profile_copy span { display: block; max-width: 110px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .profile_copy strong { color: #18201c; font-size: 14px; }
    .profile_copy span { margin-top: 3px; color: #89948d; font-size: 12px; }
    .profile_arrow { color: #89948d; cursor: pointer; }
}
@media (max-width: 640px) {
    .top_bar { height: 64px; padding: 0 16px; }
    .top_notice { text-align: left !important; font-size: 12px !important; }
    .profile_copy { display: none; }
    .profile { min-width: auto !important; }
}
</style>
